import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";
import * as PropTypes from "prop-types";

type BaseLog = (message: string) => void;
type ErrorLog = (error: Error, message: string) => void;
type VoidFunction = () => void;
export interface LegacyLogger {
  error: ErrorLog;
  info: BaseLog;
  message: BaseLog;
  warn: BaseLog;
  disableLoggers: VoidFunction;
}

interface LegacyLoggerProviderProps {
  logger: LegacyLogger;
  children: ReactNode;
}

const noop = () => {};

export const initialLogger: LegacyLogger = {
  error: noop,
  info: noop,
  message: noop,
  disableLoggers: noop,
  warn: noop,
};

const LoggerContext = createContext<LegacyLogger>(initialLogger);

export const useLogger = () => useContext(LoggerContext);

export const LoggerProvider = ({
  logger,
  children,
}: LegacyLoggerProviderProps) => {
  return (
    <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
  );
};

LoggerProvider.propTypes = {
  logger: PropTypes.object.isRequired,
};
